import { Button, Modal, message } from 'antd';
import axios from '../../backendService';

// Define folders to match the upload structure
const IMAGE_FOLDER = 'thumbnails';

const DeleteConfirmation = ({ isModalOpen, onCancel, sessionId, userId, thumbnailURL, fetchData }) => {
  const handleOk = async () => {
    try {
      // Extract filename from the full URL
      const arr = thumbnailURL.split(
        'https://hls-streaming-classroom.s3.ap-south-1.amazonaws.com/',
      );
      let fileKey = arr[arr.length - 1];
      
      // If the fileKey doesn't include the folder structure, construct it properly
      if (!fileKey.includes(IMAGE_FOLDER)) {
        // If it's just the filename, add the folder prefix
        fileKey = `${IMAGE_FOLDER}/${fileKey}`;
      }
      
      const response = await axios.delete(`/videos/deleteLiveSession/${sessionId}/${userId}/${fileKey}`);
      if (response && response.data.message) message.success(response.data.message);
      fetchData();
      onCancel();
    } catch (error) {
      console.error('Error deleting session:', error);
      message.error(`Error deleting session`);
    }
  };

  return (
    <Modal
      title="Confirm delete"
      open={isModalOpen}
      onOk={handleOk}
      onCancel={onCancel}
      footer={
        <div>
          <Button type="secondary" key="back" onClick={onCancel}>
            Cancel
          </Button>
          <Button className="text-black" type={'danger'} key="submit" onClick={handleOk}>
            Delete
          </Button>
        </div>
      }
    >
      <p>Are you sure you want to delete the session?</p>
    </Modal>
  );
};

export default DeleteConfirmation;